import { render, staticRenderFns } from "./form_model.vue?vue&type=template&id=042e32a8&scoped=true"
import script from "./form_model.vue?vue&type=script&lang=js"
export * from "./form_model.vue?vue&type=script&lang=js"
import style0 from "./form_model.vue?vue&type=style&index=0&id=042e32a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042e32a8",
  null
  
)

export default component.exports